import { useState, useEffect } from 'react';

import './style.scss';

const Pagination = ({ totalItems, itemsPerPage, onPaginate, ...rest }) => {
  const [start, setStart] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const pages = [];

  for (let i = 0; i < totalPages; i++) pages[i] = i + 1;

  const currentPages = pages.splice(start, 5);
  const onClick = e => {
    e.preventDefault();
    const { textContent: value } = e.target;
    setCurrentPage(parseInt(value));
  };

  useEffect(() => {
    const currentPageIndex = currentPages.indexOf(currentPage);

    if (currentPageIndex > 3) {
      if (currentPages.pop() !== totalPages) setStart(start + 1);
    }

    if (currentPageIndex < 1 && currentPages.shift() !== 1) setStart(start - 1);
    onPaginate(currentPage);
  }, [currentPage]);

  return (
    <ul className="custom-pagination" {...rest}>
      <li className={`page-item ${currentPage === 1 && 'disabled'}`}>
        <button
          className="btn icom"
          onClick={() => {
            if (currentPage > 1) setCurrentPage(currentPage - 1);
          }}
        >
          <span className="icon icon-chevron-left"></span>
        </button>
      </li>
      {currentPages.map((page, index) => (
        <li key={index} className={`page-item ${page === currentPage && 'active'}`}>
          <button onClick={onClick} className="btn">
            {page}
          </button>
        </li>
      ))}
      <li className={`page-item ${currentPage === totalPages && 'disabled'}`}>
        <button
          className="btn icon"
          onClick={() => {
            if (currentPage < totalPages) setCurrentPage(currentPage + 1);
          }}
        >
          <span className="icon icon-chevron-right"></span>
        </button>
      </li>
    </ul>
  );
};

export default Pagination;
